import { useEffect } from "react";

// this will be called after the dom has loaded
export default async function useScript(scriptUrl, isUsabilla) {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = scriptUrl;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      if (isUsabilla) {
        window.usabilla_live("hide");
      }
    };
  }, [scriptUrl, isUsabilla]);
}
